import { addNegativeToastWithErrorId } from 'modules/toastContainer';
import { useDispatch } from 'react-redux';
import { ApiMethod } from 'services/api';
import { useRestMutation } from 'utils/hooks/api/useRestMutation';

export const COPY_TEMPLATE_TO_CAMPAIGN_URL = '/templates/copyTemplateToCampaign';

type CopyData = {
  campaignId: number;
  templateId: number;
  dataFeedId?: number | null;
};

export const useCopyTemplateToCampaign = () => {
  const dispatch = useDispatch();
  const { mutate, isLoading } = useRestMutation(COPY_TEMPLATE_TO_CAMPAIGN_URL, ApiMethod.post);

  const copyTemplateToCampaign = (
    copyData: CopyData,
    onSuccess: () => void,
    onError: () => void,
  ) => {
    return mutate(copyData, {
      onError: (error) => {
        onError();
        const errorMessage = `Error copying template ${copyData.templateId}. Please try again later.`;
        dispatch(addNegativeToastWithErrorId(errorMessage, 'copyTemplateToCampaign', error));
      },
      onSuccess: () => {
        onSuccess();
      },
    });
  };

  return { copyTemplateToCampaign, isLoading };
};
